import React from 'react';
import SearchHeader from '../components/SearchHeader';
import TopNav from '../components/TopNav';
import GradesPage from '../components/GradesPage';
import { darkPurple } from '../utils/colors';

export default function GradesTablePage({ apiBase }) {
  const [search, setSearch] = React.useState('');
  const searchInputRef = React.useRef();
  const [searchDropdown, setSearchDropdown] = React.useState(false);

  return (
    <div className="App" style={{ background: darkPurple, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SearchHeader
        search={search}
        setSearch={setSearch}
        searchInputRef={searchInputRef}
        setSearchDropdown={setSearchDropdown}
        searchDropdown={searchDropdown}
      />
      <TopNav current="grades" />
      <div style={{ padding: 12 }}>
        <GradesPage apiBase={apiBase} />
      </div>
    </div>
  );
}

